export function initCallNow() {
    var callNowLink = document.querySelectorAll(".call-now-link");
    var callNowClose = document.querySelector(".call-now-close");

    if (!callNowLink && !callNowClose) return;

    callNowLink.forEach(link => {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            document.body.classList.toggle("call-now-open");
            document.documentElement.classList.toggle("call-now-open");

            if (window.innerWidth >= 992) {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        });
    });


    callNowClose?.addEventListener("click", function (event) {
        event.preventDefault();
        document.body.classList.remove("call-now-open");
        document.documentElement.classList.remove("call-now-open");
    });
}